import type { moneytransferApi } from 'app/src/services/welfareportal'

export const confirmTransferResponseMock: moneytransferApi.TransferResponse = {
  id: 'LQPC5MKF2BJJ',
  detailUrl: '#/shop/transfer/fondosalute/LQPC5MKF2BJJ',
  date: '2026-01-26T10:37:34.364Z',
  productName: 'Versamenti volontari Fondo Sanitario Integrativo Aziendale (Poste Vita Fondo Salute)',
  productCode: 'JZIKZQPH',
  beneficiaryId: 'JZIKZQPH',
  kind: 'FONDO_SANITARIO',
  status: {
    value: 'SUBMITTED',
    updatedAt: '2026-01-26T10:37:54.396Z',
  },
  amount: 158.4,
  orderId: 'LQPC5MKF2BJJ',
  isCancellable: false,
}

export const getTransferResponseMock: moneytransferApi.TransferResponseWithUserInfo = {
  id: 'LQPC5MKF2BJJ',
  familyMembers: [
    {
      firstName: 'ALESSANDRO',
      taxDependent: true,
      lastName: 'ROSSI',
      fiscalCode: 'RSSLSN00A01H501S',
      relationship: 'figlio_figlia',
    },
  ],
  detailUrl: '#/shop/transfer/fondosalute/LQPC5MKF2BJJ',
  date: '2026-01-26T10:37:34.364Z',
  productName: 'Versamenti volontari Fondo Sanitario Integrativo Aziendale (Poste Vita Fondo Salute)',
  productCode: 'JZIKZQPH',
  beneficiaryId: 'JZIKZQPH',
  kind: 'FONDO_SANITARIO',
  status: {
    value: 'SUBMITTED',
    updatedAt: '2026-01-26T10:37:34.364Z',
  },
  amount: 158.4,
  orderId: 'LQPC5MKF2BJJ',
  isCancellable: false,
  userInfo: {
    firstName: 'MARIO',
    lastName: 'ROSSI',
    email: 'FakeUser@MSWDATA.IT',
    fiscalCode: 'RSSMRA80A01H501U',
  },
}

export const getTransferCreationMock: moneytransferApi.TransferResponseWithUserInfo = {
  id: 'moneyTransfer',
  familyMembers: [
    {
      firstName: 'ALESSANDRO',
      taxDependent: true,
      lastName: 'ROSSI',
      fiscalCode: 'RSSLSN00A01H501S',
      relationship: 'figlio_figlia',
    },
  ],
  detailUrl: '#/shop/transfer/fondosalute/LQPC5MKF2BJJ',
  date: '2026-01-26T10:37:34.364Z',
  productName: 'Versamenti volontari Fondo Sanitario Integrativo Aziendale (Poste Vita Fondo Salute)',
  productCode: 'JZIKZQPH',
  beneficiaryId: 'JZIKZQPH',
  kind: 'FONDO_SANITARIO',
  status: {
    value: 'DRAFT',
    updatedAt: '2026-01-26T10:37:34.364Z',
  },
  amount: 158.4,
  orderId: 'LQPC5MKF2BJJ',
  isCancellable: false,
  userInfo: {
    firstName: 'MARIO',
    lastName: 'ROSSI',
    email: 'FakeUser@MSWDATA.IT',
    fiscalCode: 'RSSMRA80A01H501U',
  },
}

export const getTransfersDataMock = [
  {
    orderId: 'LQPC5MKF2BJJ',
    status: 'SUBMITTED',
    orderDate: '2026-01-26T10:37:34.364Z',
    detailPageUrl: '#/shop/transfer/fondosalute/LQPC5MKF2BJJ',
    product: {
      productId: 'JZIKZQPH',
      externalId: 'moneyTransfer|FONDO_SANITARIO',
      typology: 'moneyTransfer',
      requiredAccessLevel: 'welfare',
      merchantType: 'pws',
      serviceCategory: 'welfareArt100',
      productName: 'Versamenti volontari Fondo Sanitario Integrativo Aziendale (Poste Vita Fondo Salute)',
      signature: {
        signature: 'LS3VZrN0I7KVRL0YdOuu8DzAxU8Er9P-093tFcDtBg8',
        validUntil: 1764601023,
      },
    },
    variant: {
      variantId: 'V7C1YJ7X',
      externalId: '02_54_06|01,03,05',
      variantName: 'Pacchetto Base con nucleo 6 mesi',
      priceDetails: {
        billingData: '9jBYV8fXw/+O/xlzF6q1jIxFiAot92cVCPby87+mENIbpT1N',
        facePrice: 158.4,
        finalGrossPrice: 158.4,
        taxClass: '',
        taxPercentage: 0,
      },
      active: true,
      signature: {
        signature: 'KSFvuAAVX4V1q7YA-AFtZQAiF9CkgKBeFnR1Z3zaunE',
        validUntil: 1764601023,
      },
    },
    userInfo: {
      userId: 'abc',
      firstName: 'MARIO',
      lastName: 'ROSSI',
      email: 'FakeUser@MSWDATA.IT',
      fiscalCode: 'RSSMRA80A01H501U',
      membershipId: 'fakeMembership1',
    },
    productAdditionalInfo: {},
    beneficiaries: {
      user: false,
      familyMembers: [
        {
          familyMemberId: 'W4RASEHM13F58',
          firstName: 'ALESSANDRO',
          lastName: 'ROSSI',
          fiscalCode: 'RSSLSN00A01H501S',
          taxDependent: true,
          relationship: 'figlio_figlia',
          signature: {
            signature: 'MSHrDlIE9WE8fZK9W7NGw4cvCB9kKRp9INEmWyYXtBI',
            validUntil: 1729674566,
          },
        },
      ],
    },
    priceDetails: {
      grossPrice: 158.4,
      netPrice: 158.4,
      taxPercentage: 10,
      taxAmount: 0,
    },
    isCancelable: true,
  },
]
